module.exports = __webpack_public_path__ + "img/专利证书10_绿色建筑在线智能设计及评估软件v1.0.a9596218.png";